import  store  from '@/store.js'
export default function (Vue) {
  Vue.snackbar = {
    show (message, timeout = 4000, color = 'deep-purple accent-4') {
      const toast = { color, timeout, message }
      store.commit('showSnackbar', toast)
    },
    success (message, timeout = 4000, color = 'green darken-1') {
      const toast = { color, timeout, message }
      store.commit('showSnackbar', toast)
    },
    warning (message, timeout = 4000, color = 'orange accent-4') {
      const toast = { color, timeout, message }
      store.commit('showSnackbar', toast)
    },
    error (message, timeout = 4000, color = 'red accent-4') {
      const toast = { color, timeout, message }
      store.commit('showSnackbar', toast)
    },
    hide () {
      store.commit('hideSnackbar')
    },
    reset () {
      store.commit('resetSnackbar')
    }
  }
  Object.defineProperties(Vue.prototype, {
    $snackbar: {
      get: () => {
        return Vue.snackbar
      }
    }
  })
}
